import _taggedTemplateLiteral from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/UDFGE-ESHOP4-JOB1/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2;
import { jsx, jsxs } from 'react/jsx-runtime';
import { Radio } from '@dls/web';
import styled from 'styled-components';
import CustomController from './CustomController.js';
import { buildErrorMessage } from './helpers/utils.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};
const RadioGroupController = _a => {
  var _b = _a,
    {
      name,
      control,
      defaultValue,
      rules,
      shouldUnregister
    } = _b,
    radioProps = __objRest(_b, ["name", "control", "defaultValue", "rules", "shouldUnregister"]);
  return /* @__PURE__ */jsx(CustomController, {
    name,
    control,
    defaultValue,
    rules,
    shouldUnregister,
    render: _ref => {
      let {
        field: {
          value,
          ref,
          onChange
        },
        fieldState: {
          error
        }
      } = _ref;
      const errorMessage = buildErrorMessage({
        error,
        rules
      });
      return /* @__PURE__ */jsxs(SCWrapper, {
        children: [/* @__PURE__ */jsx(Radio.InputGroup, __spreadProps(__spreadValues({}, radioProps), {
          name,
          error: errorMessage,
          value,
          onChange: e => {
            onChange(e.target.value);
            if (radioProps.onChange) {
              radioProps.onChange(e);
            }
          }
        })), /* @__PURE__ */jsx(SCFocusHelpInput, {
          ref
        })]
      });
    }
  });
};
const SCWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n"])));
const SCFocusHelpInput = styled.input(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 0;\n  height: 0;\n  padding: 0;\n  border: 0;\n  position: absolute;\n  top: 16px;\n  z-index: -1;\n"])));
export { RadioGroupController as default };